var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component card-image",class:_vm.classes,style:({width: (_vm.size + "px"), height: (_vm.size + "px"), backgroundImage: _vm.src ? ("url('" + _vm.src + "')") : null})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }